<template>
    <main>
        <div v-if="!fetching">
            <h1><img alt="Reddit Investigator Logo" src="../assets/logo.svg">Reddit Investigator</h1>
            <div class="search-field">
                <el-form @submit.prevent="search">
                    <el-form-item :error=error :show-message="error.length>0">
                        <el-input v-model=username
                                  class="ri-input"
                                  @keypress.enter.native="search"
                                  placeholder="Username"
                                  minlength="1"
                                  maxlength="20"
                                  autofocus>
                            <i slot="suffix"
                               class="el-input__icon"
                               :class="{'el-icon-search':!loading, 'el-icon-loading':loading}"
                               @click="search"/>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <Loader v-if="fetching" :onStop="stop"/>
    </main>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Loader from "../components/Loader";

    export default {
        components: {Loader},
        data() {
            return {username: 'Duiker101', error: '', loading: false, fetching: false}
        },
        computed: {
            ...mapGetters(['comments'])
        },
        methods: {
            ...mapActions(['fetchUser']),
            ...mapActions(['fetchPage']),
            ...mapActions(['clearHistory']),
            search() {
                if (this.username.length === 0) {
                    this.error = 'Specify a username'
                    return;
                }

                this.error = ''
                this.loading = true;
                this.fetchUser(this.username)
                    .finally(() => this.loading = false)
                    .then(data => {
                        this.error = ''
                        this.username = data.name;
                        this.loadHistory()
                    })
                    .catch(e => {
                        if (e.status === 404)
                            this.error = 'User not found'
                        if (e.status === 505)
                            this.error = 'Server Error, try again'
                    })
            },
            loadHistory() {
                this.fetching = true;
                this.clearHistory()
                this.loadPage('')
            },
            loadPage(after) {
                this.fetchPage({username: this.username, after}).then(data => {
                    // todo wait
                    if (data.after === null || !this.fetching)// || this.comments.length > 0)
                        this.finish()
                    else
                        setTimeout(() => this.loadPage(data.after), 1)
                })
            },
            stop() {
                this.fetching = false;
            },
            finish() {
                this.fetching = false
                this.$router.replace('/' + this.username);
            }
        },
        mounted() {
            if (!empty(this.$route.params.user)) {
                this.username = this.$route.params.user
                this.search();
            }
        }
    }
</script>

<style scoped>
    h1 {
        text-align: center;
        font-weight: bold;
        font-size: 3rem;
        text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
        margin-bottom: 1em;
        color: white;
    }

    img {
        height: 1.5em;
        vertical-align: bottom;
    }

    .search-field {
        width: 300px;
        margin: auto auto;
    }

    main {
        grid-column: 2;
        /*grid-row: 2;*/
        /*height: 100%;*/
    }

    i {
        cursor: pointer;
    }
</style>
